import "../styles/navbar.css";

var currentLink = "";
var scrollCheckDisabled = false;

// ripped off my other project, needs tons of fixing and cleaning up

function scrollToElementById(id) {
    var element = document.getElementById(id);
    element.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
}

export function ul(index, calledFromScroll = false) {
    return 0;

    const el = document.querySelectorAll("#Nav ul li")[index];
    let links = document.querySelectorAll("#Nav ul li div");
    const rect = el.getBoundingClientRect()
    const navUnderline = document.getElementById("underline");

    var offset = (rect.left - (window.innerWidth / 2)) + el.offsetWidth / 2;
    offset = offset + 18

    navUnderline.style.transform = `translateX(${offset}px)`;
    links.forEach(link => { link.classList.remove("active") })
    links[index].classList.add("active");
    
    if (!calledFromScroll) {
        scrollCheckDisabled = true;
        setTimeout(() => {scrollCheckDisabled = false;}, 400);
    }
}

export default function NavBar() {
    var navBar = null;
    var navUnderline = null;

    function scrollFunction() {
        // Contact / About Section checker

        currentLink = window.location.href.split("/")[3].replace("#", "");
        const linkafter = window.location.href.split("/")[4];

        if(currentLink){
            if(scrollCheckDisabled) {return;}
            let contact = document.getElementById("ContactCheck");
            let about = document.getElementById("AboutCheck");

            if (contact.classList.contains("aos-animate")) {ul(4, true); currentLink = "Contact";}
            else if (about.classList.contains("aos-animate")) {ul(3, true); currentLink = "About";}
            else {ul(2, true); currentLink = "";}

        } else if (currentLink = "blog" && linkafter !== undefined) { // top scrollbar
            var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            var scrolled = (winScroll / height) * 100;
            document.getElementById("myBar").style.width = scrolled + "%";
        }

        // NavBar size
        if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
          navBar.style.height = "70px";
          navUnderline.style.top = "56px";
          if(currentLink === "blog" && linkafter !== undefined) {document.getElementsByClassName("progress-container")[0].style.top = "70px"}
        } else {
          navBar.style.height = "80px";
          navUnderline.style.top = "66px";
          if(currentLink === "blog" && linkafter !== undefined) {document.getElementsByClassName("progress-container")[0].style.top = "80px"}
        }
      }

    return (
        <div id="NavBarWrapper">
            <div id="NavBar">
                <div id="Nav">
                    <ul>
                        <li className="flexcenter"><div onClick={() => {scrollToElementById("About"); currentLink = "About"}}>
                            About</div></li>
                        <li className="flexcenter"><div onClick={() => {scrollToElementById("TestHeader"); currentLink = "Demo"}}>
                            Demo</div></li>
                        <li><div onClick={() => {ul(2); currentLink = ""}}>
                            <img id="LogoImg" src="https://static-00.iconduck.com/assets.00/home-2-icon-512x510-ekiuox6t.png" /></div></li>
                        <li className="flexcenter"><div onClick={() => {scrollToElementById("Feedback"); currentLink = "Contact"}}>
                            Feedback</div></li>
                        <li className="flexcenter"><div onClick={() => {scrollToElementById("Team"); currentLink = "Team"}}>
                            Team</div></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
/*                        <div id="underline"></div>*/
